<template>
    <div>
        <template v-if="!showEmailValidation || !!emailValidationInModal">
            <form :action="action" class="registration-form" method="POST" v-if="form">
                <input type="hidden" name="_token" :value="csrkToken">

                <md-card class="profil-form">
                    <md-card-header>
                        <h2 class="md-title md-title-dark page-sub-title !text-lg" v-html="title" />
                    </md-card-header>
                    <md-card-content>
                        <transition name="slide-y-top">
                            <div>
                                <div v-if="!hideEntityType" :class="{ 'md-invalid': !!errors.entity_type }"
                                     class="entity-type-container"
                                >
                                    <span class="!text-sm">{{ entityTypeSelectionLabel }}</span>
                                    <entity-type-input dusk="entity-type-input" v-model="fData.entity_type" />
                                    <span v-if="errors.entity_type" class="md-error">{{
                                        errors.entity_type ? errors.entity_type[0] : ""
                                    }}</span>
                                </div>
                                <!--
                                <div class="pilot-owner-links">
                                    <a href="/registration-other/pilot">{{ $t("registration.you-are-pilot") }}</a>
                                    <a href="/registration-other/owner">{{ $t("registration.you-are-owner") }}</a>
                                </div>
                                !-->
                                <div class="form-row mb-2" v-if="fData.entity_type == 'company'">
                                    <FormInput
                                        input-name="entity_name"
                                        v-model="fData.entity_name"
                                        :disabled="submitting ? 'disabled' : null"
                                        dusk="entity-name-input"
                                        required
                                        :placeholder="$t('registration.entity-name')"
                                        :has-error="!!errors.entity_name"
                                        :error="errors.entity_name ? errors.entity_name[0] : ''"
                                        prepend-icon="building"
                                    />
                                </div>
                                <div class="form-row mb-2">
                                    <div class="col mb-2 md:mb-0 md:mr-1">
                                        <FormInput
                                            input-name="lastname"
                                            v-model="fData.lastname"
                                            :disabled="submitting ? 'disabled' : null"
                                            required
                                            :placeholder="$t('registration.lastname')"
                                            :has-error="!!errors.lastname"
                                            :error="errors.lastname ? errors.lastname[0] : ''"
                                            prepend-icon="user"
                                        />
                                    </div>
                                    <div class="col md:ml-1">
                                        <FormInput
                                            input-name="firstname"
                                            v-model="fData.firstname"
                                            :disabled="submitting ? 'disabled' : null"
                                            required
                                            :placeholder="$t('registration.firstname')"
                                            :has-error="!!errors.firstname"
                                            :error="errors.firstname ? errors.firstname[0] : ''"
                                            prepend-icon="user"
                                        />
                                    </div>
                                </div>

                                <!--
                                <div class="form-row">
                                    <md-field :class="{ 'md-invalid': !!errors.role }">
                                        <label>{{ $t("registration.job-label") }}</label>
                                        <md-select
                                            name="role"
                                            dusk="role-input"
                                            :disabled="submitting ? 'disabled' : null"
                                            v-model="fData.role"
                                            required
                                        >
                                            <md-option
                                                :value="role.id"
                                                :key="'role_' + role.key"
                                                v-for="role in userRoles"
                                            >
                                                {{ role.label }}
                                            </md-option>
                                        </md-select>
                                        <span class="md-error">{{
                                            errors.role ? errors.role[0] : ""
                                        }}</span>
                                    </md-field>
                                </div>
                                !-->
                                <div class="form-row mb-2">
                                    <city-input name="city_id" :label="$t('registration.your-city')" :no-label="true"
                                                v-model="fData['city_id']" :city-name="fData['city_name']"
                                                :input-error="errors['city_id']" :disabled="submitting ? 'disabled' : null"
                                                dusk="city-input"
                                                required
                                                new-version
                                                icon="city"
                                    />
                                </div>

                                <div class="form-row mb-2">
                                    <phone-field name="phone" v-model="fData.mobile" :errors="errors.mobile"
                                                 :label="$t('registration.mobile')" mobile-only :country-id="countryId" ref="phoneInput"
                                                 :disabled="submitting ? 'disabled' : null" required
                                                 new-version
                                    />
                                </div>

                                <div v-if="showEmailField" class="mb-2">
                                    <FormInput type="email"
                                               input-name="email"
                                               v-model="fData.email"
                                               :disabled="submitting ? 'disabled' : null"
                                               required
                                               :placeholder="$t('registration.your-email')"
                                               :has-error="!!errors.email"
                                               :error="errors.email ? errors.email[0] : ''"
                                               prepend-icon="at"
                                               dusk="email-input"
                                    />
                                </div>
                                <div class="mb-2">
                                    <FormInput
                                        input-type="password"
                                        input-name="password"
                                        v-model="fData.password"
                                        :disabled="submitting ? 'disabled' : null"
                                        required
                                        :placeholder="$t('registration.password')"
                                        :has-error="!!errors.password"
                                        :error="errors.password ? errors.password[0] : ''"
                                        prepend-icon="lock"
                                        dusk="password-input"
                                        @focus="passwordFieldFocused = true; passwordFieldTouched = true;"
                                        @blur="passwordFieldFocused = false"
                                    />
                                </div>
                                <!--
                                <div class="form-row">
                                    <md-field
                                        :class="{
                                            'md-invalid': !!errors.password_confirmation,
                                        }"
                                    >
                                        <label>{{
                                            $t("registration.password-confirmation")
                                        }}</label>
                                        <md-input
                                            type="password"
                                            name="password_confirmation"
                                            v-model="fData.password_confirmation"
                                            :disabled="submitting ? 'disabled' : null"
                                            required
                                        />
                                        <span class="md-error">{{
                                            errors.password_confirmation
                                                ? errors.password_confirmation[0]
                                                : ""
                                        }}</span>
                                    </md-field>
                                </div>
                                !-->
                                <div class="mb-2">
                                    <div class="relative">
                                        <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                            <font-awesome-icon :icon="['fas', 'suitcase']" :style="{ color: '#a0a0a0' }" />
                                        </div>
                                        <select name="your-need"
                                                v-model="fData.yourNeed"
                                                :disabled="submitting"
                                                dusk="your-need-input"
                                                class="block appearance-none bg-white border border-gray-200 text-sm rounded-md w-full h-[34px] p-1.5 ps-10 pe-9 focus:outline-none focus:border-primary-dark-50"
                                                :class="{ 'italic !text-gray-400': !fData.yourNeed, '!text-primary-dark-50': !!fData.yourNeed, 'border-red-500': !!errors.yourNeed }"
                                        >
                                            <option :value="null" disabled>{{ $t("registration.your-need") }}</option>
                                            <option v-for="need in userNeeds" :key="'need_' + need.id" :value="need.id" class="not-italic text-primary-dark-50">
                                                {{ need.label }}
                                            </option>
                                        </select>
                                        <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#a0a0a0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6l6 -6"></path></svg>
                                        </div>
                                    </div>
                                    <p class="my-2 text-xs text-red-500" v-if="errors.yourNeed">{{ errors.yourNeed[0] }}</p>
                                </div>
                                <div class="mb-2">
                                    <div class="relative">
                                        <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                            <font-awesome-icon :icon="['fas', 'bullhorn']" :style="{ color: '#a0a0a0' }" />
                                        </div>
                                        <select name="know"
                                                v-model="fData.know"
                                                :disabled="submitting"
                                                dusk="know-input"
                                                class="block appearance-none bg-white border border-gray-200 text-sm rounded-md w-full h-[34px] p-1.5 ps-10 pe-9 focus:outline-none focus:border-primary-dark-50"
                                                :class="{ 'italic !text-gray-400': !fData.know, '!text-primary-dark-50': !!fData.know, 'border-red-500': !!errors.know }"
                                        >
                                            <option :value="null" disabled>{{ $t("registration.find-way") }}</option>
                                            <option v-for="know in findWay" :key="'know_' + know.id" :value="know.id" class="not-italic text-primary-dark-50">
                                                {{ know.label }}
                                            </option>
                                        </select>
                                        <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#a0a0a0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6l6 -6"></path></svg>
                                        </div>
                                    </div>
                                    <p class="my-2 text-xs text-red-500" v-if="errors.know">{{ errors.know[0] }}</p>
                                </div>
                                <!--
                                <div class="form-col form-cgu text-grey-light">
                                    <md-checkbox
                                        name="cgu"
                                        id="cgu"
                                        v-model="fData.accept_mail"
                                        :disabled="submitting ? 'disabled' : null"
                                        >{{ $t("registration.accept-email") }}</md-checkbox
                                    >

                                    <span class="md-error">{{
                                        errors.accept_mail ? errors.accept_mail[0] : ""
                                    }}</span>
                                </div>
                                !-->
                                <div class="form-row form-row-submit">
                                    <div class="form-submit-button">
                                        <p class="accept-tos" v-html="$t('registration.accept-tos')" />
                                        <submit-button type="submit" class="registration-standalone-button"
                                                       :submitting="submitting" :label="$t('registration.create_account')"
                                                       @click="onSubmit()" dusk="submit-profile-button"
                                        />
                                    </div>
                                </div>
                                <div class="form-row form-row-already-member">
                                    <a href="#" @click="login">{{ $t('registration.already-member-log-in') }}</a>
                                </div>
                                <hr class="pilot-owner-separator">
                                <div class="form-row pilot-owner-links">
                                    <a href="/registration-other/pilot">{{ $t('registration.you-are-pilot') }}</a>
                                    <span class="pilot-owner-divider">|</span>
                                    <a href="/registration-other/owner">{{ $t('registration.you-are-owner') }}</a>
                                </div>
                            </div>
                        </transition>
                    </md-card-content>
                </md-card>
            </form>
        </template>
        <template v-if="showEmailValidation">
            <div v-if="emailValidationInModal" class="md-overlay md-fixed md-dialog-overlay" />
            <md-dialog v-if="emailValidationInModal" :md-active="true" :md-click-outside-to-close="false" :md-close-on-esc="false">
                <email-validation :email="fData.email" :return-location="returnLocation" />
            </md-dialog>
            <email-validation v-else :email="fData.email" :return-location="returnLocation" />
        </template>
    </div>
</template>

<script>
import PhoneField from '../../widgets/PhoneFieldComponent.vue';
import CityInput from '../../widgets/CityInputComponent.vue';
import EntityTypeInput from '../../widgets/EntityTypeInput.vue';
import FormInput from './formInput.vue';
import emailValidation from './emailValidation.vue';

export default {
    components: { PhoneField, CityInput, EntityTypeInput, FormInput, emailValidation },
    props: {
        action: {
            type: String,
            required: true,
        },
        formString: {
            type: String,
            required: true,
        },
        fromAirportId: {
            type: String,
            default: '',
        },
        toAirportId: {
            type: String,
            default: '',
        },
        countryId: {
            type: String,
        },
        entityRolesString: {
            type: String,
        },
        templateString: {
            type: String,
        },
        introPhrase: {
            type: String,
            default: 'fill-profile-freemium',
        },
        // displayLegalStatusField: {
        //     type   : Boolean,
        //     default: true,
        // },
        showEmailField: {
            type: Boolean,
            default: false,
        },
        entityTypesString: {
            type: String,
            required: true,
        },
        userRolesString: {
            type: String,
            required: true,
        },
        registrationPageId: String,
        displayFormProp: {
            type: Boolean,
            default: false
        },
        hideEntityType: {
            type: Boolean,
            default: false,
        },
        findWayString: {
            type: String,
            required: true,
        },
        userNeedsString: {
            type: String,
            required: true,
        },
        withSearch: {
            type: Boolean,
            default: false,
        },
        emailValidationInModal: {
            type: Boolean,
            default: false,
        },
        withEmailValidation: {
            type: Boolean,
            default: false,
        },
        engineSearchId: {
            type: String,
            default: null
        },
        parentDomain: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            fData: {
                lastname: '',
                firstname: '',
                email: '',
                mobile: '',
                password: '',
                password_confirmation: '',
                airport_id: null,
                city_id: null,
                accept_mail: 1,
                // legal_status         : null,
                entity_type: null,
                entity_name: null,
                role: null,
                know: null,
                yourNeed: null
            },
            errors: {
                lastname: null,
                firstname: null,
                email: null,
                mobile: null,
                password: null,
                password_confirmation: null,
                airport_id: null,
                city_id: null,
                accept_mail: null,
                // legal_status         : null,
                entity_type: null,
                entity_name: null,
                role: null,
                know: null,
                yourNeed: null
            },
            csrkToken: Laravel.csrfToken,
            submitting: false,
            returnLocation: null,
            showEmailValidation: false,
        };
    },
    computed: {
        form() {
            return this.parseProp(this.formString);
        },
        template() {
            return this.parseProp(this.templateString) || {};
        },
        title() {
            if (
                !this.template.form_title ||
                !this.template.form_title[this.$i18n.locale()]
            ) {
                return this.$t('registration.' + this.introPhrase);
            }

            return this.template.form_title[this.$i18n.locale()];
        },
        entityTypes() {
            return this.parseProp(this.entityTypesString);
        },
        userRoles() {
            return this.parseProp(this.userRolesString);
        },
        entityTypeSelectionLabel() {
            if (
                !this.template.entity_type_selection_label ||
                !this.template.entity_type_selection_label[this.$i18n.locale()]
            ) {
                return this.$t('registration.flight-as-label');
            }
            return this.template.entity_type_selection_label[this.$i18n.locale()];
        },
        findWay() {
            return this.parseProp(this.findWayString);
        },
        userNeeds() {
            return this.parseProp(this.userNeedsString);
        },
        searchDatas() {
            if (!this.withSearch) {
                return null;
            }
            const params = new URLSearchParams(window.location.search);
            const tripType = params.get('tripType');
            if (tripType === 'multi') {
                return null;
            }
            return {
                engineSearchId: this.engineSearchId,
                goneDate: params.get('goneDate'),
                returnDate: params.get('returnDate'),
                tripType,
                from: params.get('from'),
                to: params.get('to'),
                fromId: params.get('fromId'),
                toId: params.get('toId'),
                nbPassengers: params.get('nbPassengers'),
                referal: params.get('referal'),
            };
        },
    },
    mounted() {
        this.setupForm();
        if (this.hideEntityType) {
            this.fData.entity_type = 'company';
        }
    },
    methods: {
        parseProp(prop) {
            if (!prop) {
                return;
            }

            return JSON.parse(prop);
        },
        setupForm() {
            if (!this.form) {
                return;
            }

            for (let i of Object.keys(this.form)) {
                this.fData[i] = this.form[i];
            }

            this.fData.password_confirmation = this.fData.password;

            if (this.fromAirportId) {
                this.fData.airport_id = this.fromAirportId;
            }
            if (this.toAirportId) {
                this.fData.destination_airport_id = this.toAirportId;
            }
        },
        login() {
            // Build a safe redirect URL to /member/ with optional search params
            const baseUrl = '/member/';
            let url = baseUrl;

            if (this.withSearch && this.searchDatas) {
                const params = new URLSearchParams();
                try {
                    // URLSearchParams will handle encoding
                    params.set('openfly-search-engine-params', JSON.stringify(this.searchDatas));
                } catch (e) {
                    // If stringify fails for any reason, fall back to no extra params
                }
                const qs = params.toString();
                if (qs) {
                    url = `${baseUrl}?${qs}`;
                }
            }

            // Use location.assign for a proper navigation
            window.location.assign(url);
        },
        onSubmit() {

            this.submitting = true;

            for (let i of Object.keys(this.errors)) {
                this.errors[i] = null;
            }

            // Inject cross-domain-safe payload as a serialized param
            const crossDomainParams = {};
            if (this.withSearch && this.searchDatas) {
                crossDomainParams['openfly-search-engine-params'] = JSON.stringify(this.searchDatas);
            } else if (this.withSearch) {
                crossDomainParams['go-to-fly'] = true;
            }

            axios
                .post(this.action, {
                    ...this.fData,
                    ...crossDomainParams,
                    registration_page_id: this.registrationPageId,
                    parent_domain: this.parentDomain,
                })
                .then(({ data }) => {
                    if (data.status === 'ok') {

                        // Track account creation click in Google Analytics via GTM dataLayer
                        const entityType = this.fData.entity_type || 'unknown';
                        const entityEvent =
                            entityType === 'company'
                                ? 'click_create_account_company'
                                : entityType === 'individual'
                                    ? 'click_create_account_individual'
                                    : 'click_create_account';
                        const matomoAction =
                            entityType === 'company'
                                ? 'Click Create Account Company'
                                : entityType === 'individual'
                                    ? 'Click Create Account Individual'
                                    : 'Click Create Account';

                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': entityEvent,
                                'event_category': 'Registration',
                                'event_label': 'Create Account Button',
                                'entity_type': entityType,
                                'email': !!this.fData.email,
                            });
                        }

                        if (typeof window.matomoTrackEvent === 'function') {
                            window.matomoTrackEvent('Registration', matomoAction, 'Create Account Button');
                        }
                        //window.location = data.redirect;
                        this.returnLocation = data.redirect;
                        if (this.withEmailValidation) {
                            this.showEmailValidation = true;
                        } else {
                            // Defer navigation to next tick so sendBeacon requests
                            // (Matomo + GA via GTM) are queued before unload.
                            setTimeout(() => { window.location = data.redirect; }, 0);
                        }
                    }

                    this.submitting = false;

                })
                .catch(
                    ({
                        response: {
                            data: { errors },
                        },
                    }) => {
                        this.submitting = false;

                        for (let i of Object.keys(this.errors)) {
                            this.errors[i] = errors[i];
                        }
                    }
                );
        },
    },
};
</script>

<style lang="scss" scoped>
.text-grey-light {
    color: rgba(0, 0, 0, 0.54);
}
</style>
<style lang="scss">
@import "~styles/_variables";

.registration-form {
    .md-title em {
        font-weight: 400;
        font-size: 0.95em;
    }

    .md-error {
        color: #ff1744;
        opacity: 1;
        transform: translateZ(0);
    }

    .pilot-owner-links {
        display: flex;
        flex-direction: row;
        margin: 10px 6px;
        margin-bottom: 0;
        a {
            font-size: 13px;
            text-decoration: underline;
            line-height: 26px;
        }
    }

    .entity-type-container {
        display: flex;
        flex-direction: column;
        width: auto;

        span {
            font-size: 16px;
            font-weight: 600;
            color: $primary-color-dark;
        }

        span.md-error {
            color: var(--md-theme-default-fieldvariant, #ff1744);
            height: 20px;
            font-size: 12px;
            transition: .3s cubic-bezier(.4, 0, .2, 1);
            font-weight: normal;
        }

        .entity-type-input {

            //  justify-content: space-around;
            button {
                margin: 10px 15px;
            }
        }

        @media (max-width: $mobile-top-breakpoint) {
            //margin-top: 30px;
        }

        @media (min-width: $desktop-bottom-breakpoint) {
            .entity-type-input {
                justify-content: flex-start;

                button {
                    margin-left: 0px;
                }
            }
        }
    }

    .md-invalid {
        margin-bottom: 50px;
    }

    .form-row-submit {
        margin-top: 0px !important;

        .accept-tos {
            width: 100%;
            margin-top: 0px;
            margin-bottom: 10px;
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    // .form-row.is-legal-status {
    //     margin-left: 5px;
    //     margin-right: 5px;
    //     margin-bottom: 1em;
    //     display: flex;
    //     flex-direction: column;

    //     .legal-status-label {
    //         width: fit-content;
    //         margin-top: .2em;
    //         margin-bottom: -.2em;
    //         font-size: 16px;
    //         line-height: 20px;
    //         color: rgba(0, 0, 0, 0.54);
    //         transition: .4s cubic-bezier(.25, .8, .25, 1);
    //         transition-duration: .3s;
    //         position: relative;

    //         &:after {
    //             content: '*';
    //             top: 2px;
    //             right: 0;
    //             line-height: 1em;
    //             vertical-align: top;
    //             transform: translateX(calc(100% + 2px));
    //             position: absolute;
    //         }
    //     }

    //     .legal-status-fields {
    //         display: flex;
    //         flex-wrap: wrap;
    //     }

    //     .md-invalid,
    //     .md-error {
    //         color: #ff1744;
    //         color: var(--md-theme-default-fieldvariant, #ff1744);
    //     }
    //     .md-error {
    //         margin-top: -.7em;
    //         font-size: 12px;
    //     }

    //     .md-radio:first-of-type {
    //         margin-right: 2em;
    //         margin-bottom: 0;
    //     }
    //     .md-radio-label {
    //         font-size: 16px;
    //         color: rgba(0, 0, 0, 0.54);
    //         position: static;
    //     }
    // }

    .password-rules {
        font-size: 12px;
    }

    @media (max-width: $mobile-top-breakpoint) {
        margin-bottom: 30px;
    }

    .form-row-already-member {
        text-align: center;
        margin-top: 10px;
        padding-left: 5px;
        padding-right: 5px;

        a {
            color: $primary-color-dark;
            text-decoration: underline;
            font-size: 12px;
        }
    }

    .pilot-owner-separator {
        border: none;
        border-top: 1px solid #ddd;
        margin: 10px 20px;
    }

    .pilot-owner-links {
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        gap: 6px;

        // "Je suis pilote | Je suis propriétaire" groupés au centre sur une seule
        // ligne : on neutralise le flex-grow/flex-basis hérité de .form-row sur
        // TOUS les enfants (liens ET séparateur), sinon le | s'étire et écarte les liens
        > * {
            flex: 0 0 auto;
        }

        a {
            white-space: nowrap;
            color: $primary-color-dark;
            text-decoration: underline;
            font-size: 12px;
        }

        .pilot-owner-divider {
            color: #999;
            font-size: 12px;
        }
    }

    .registration-standalone-button {
        padding: 10px 20px;
    }
}

// Landing page « HTML personnalisé » (balise $$form$$) : textes à la taille du formulaire /ask-contact,
// et en mobile le formulaire se rapproche des bords de l'écran.
.registration-custom-html .registration-form {
    .entity-type-container > span:not(.md-error) {
        font-size: 16px !important;
    }

    .entity-type-input .md-button,
    .PhoneFieldComponent .nv-button,
    input,
    select {
        font-size: 16px;
    }

    .form-row-submit .accept-tos {
        font-size: 15px;
    }

    .form-row-already-member a,
    .pilot-owner-links a,
    .pilot-owner-links .pilot-owner-divider {
        font-size: 14px;
    }

    @media (max-width: $mobile-top-breakpoint) {
        .profil-form {
            max-width: 100%;
            margin-left: 0;
            margin-right: 0;
        }

        .md-card-header,
        .md-card-content {
            padding-left: 8px;
            padding-right: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/form.vue